import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { Mission } from "@/components/sections/Mission";
import { Audience } from "@/components/sections/Audience";
import { Products } from "@/components/sections/Products";
import { Blends } from "@/components/sections/Blends";
import { Ritual } from "@/components/sections/Ritual";
import { Reviews } from "@/components/sections/Reviews";
import { Social } from "@/components/sections/Social";
import { FAQ } from "@/components/sections/FAQ";
import { Newsletter } from "@/components/sections/Newsletter";
import { Footer } from "@/components/sections/Footer";
import { StickyCartButton } from "@/components/StickyCartButton";
import { CartDrawer } from "@/components/CartDrawer";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { ErrorBoundary } from "@/components/ErrorBoundary";

const Index = () => {
  useScrollAnimation();

  return (
    <div className="overflow-x-hidden">
      <Navbar />
      <ErrorBoundary section="Hero">
        <Hero />
      </ErrorBoundary>
      <Mission />
      <Audience />
      <ErrorBoundary section="Products">
        <Products />
      </ErrorBoundary>
      <ErrorBoundary section="Blends">
        <Blends />
      </ErrorBoundary>
      <Ritual />
      <Reviews />
      <Social />
      <FAQ />
      <Newsletter />
      <Footer />
      <StickyCartButton />
      <CartDrawer />
    </div>
  );
};

export default Index;